module.exports = __webpack_public_path__ + "83a54055.png";